export const smarpayColor = "#F18800";

//------------------------------------
// LINE - CHART JS
//------------------------------------
export const linechartMock = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Aug", "Sep", "Oct"],
  datasets: [
    {
      label: "TOTAL BUDGET",
      data: [100, 210, 180, 454, 454, 230, 230, 656, 656, 350, 350, 210, 410],
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: "#6259ca",
      pointBackgroundColor: "ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.4,
    },
    {
      label: "AMOUNT USED",
      data: [200, 530, 110, 110, 480, 520, 780, 435, 475, 738, 454, 454, 230],
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: smarpayColor, //"rgb(183, 179, 220,0.5)",
      pointBackgroundColor: "#ffffff",
      pointRadius: 0,
      type: "line",
      //borderDash: [7, 3],
      tension: 0.3,
    },
  ],
};

export const linechartMock2 = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Aug", "Sep", "Oct"],
  datasets: [
    {
      label: "Twint",
      data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 500)),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: smarpayColor,
      pointBackgroundColor: "ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.4,
    },
    {
      label: "Credit Card",
      data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 100)),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: "pink",
      pointBackgroundColor: "#ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.3,
    },
    {
      label: "Apple/Google pay",
      data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 200)),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: "lightgreen",
      pointBackgroundColor: "ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.4,
    },
    {
      label: "Swisscom pay",
      data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 50)),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: "green",
      pointBackgroundColor: "#ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.3,
    },
    {
      label: "Postfinance card",
      data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 20)),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: "blue",
      pointBackgroundColor: "#ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.3,
    },
  ],
};

export const linechartOptionsMock = {
  responsive: true,
  maintainAspectRatio: false,

  plugins: {
    /*title: {
      display: true,
          text: 'Chart.js Line Chart'
    },*/
    /*legend: {
      position: "top",
      display: true,
    },*/
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      ticks: {
        fontColor: "#c8ccdb",
      },
      barPercentage: 0.7,
      display: true,
      grid: {
        borderColor: "rgba(119, 119, 142, 0.2)",
      },
    },
    y: {
      display: true,
      grid: {
        borderColor: "rgba(119, 119, 142, 0.2)",
      },
      scaleLabel: {
        display: true,
        labelString: "Thousands",
        fontColor: "transparent",
      },
      ticks: {
        beginAtZero: true,
      },
    },
  },
  interaction: {
    intersect: false,
  },
};

//------------------------------------
// PIE - CHART JS
//------------------------------------
export const piechartMock = {
  labels: ["Red", "Orange", "Yellow", "Blue", "Green"],
  datasets: [
    {
      data: [20, 20, 30, 5, 25],
      backgroundColor: ["#6259ca", "#53caed", "#01b8ff", "#f16d75", "#29ccbb"],
    },
  ],
  hoverOffset: 4,

  legend: {
    display: true,
    position: "right",
    labels: {
      fontColor: "rgb(255, 99, 132)",
    },
  },
};

export const piechartOptions = {
  //responsive: true,
  //maintainAspectRatio: true,

  plugins: {
    legend: {
      display: true,
      position: "bottom",
      align: "center",
      fullSize: true,
      labels: {
        boxWidth: 20,
        padding: 5,
      },
    },
    /*title: {
      display: false,
      text: "Chart.js Line Chart",
    },*/
  },
  /*scales: {
    x: {
      stacked: true, // Enable stacking for the x-axis
    },
    y: {
      stacked: true, // Enable stacking for the y-axis
    },
  },*/
};

export const dougnutChartMock = {
  labels: ["Red", "Orange", "Yellow", "Blue", "Green"],
  datasets: [
    {
      data: [20, 20, 30, 5, 25],
      backgroundColor: ["#6259ca", "#53caed", "#01b8ff", "#f16d75", "#29ccbb"],
    },
    {
      data: [20, 20, 30, 5, 25],
      backgroundColor: ["#6259ca", "#53caed", "#01b8ff", "#f16d75", "#29ccbb"],
    },
  ],
  hoverOffset: 4,

  legend: {
    display: true,
      position: "top",
      align: "center",
      fullSize: true,
      labels: {
        boxWidth: 20,
        padding: 5,
      },
  },
}

export const doughnutOptions = {
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      align: "center",
      fullSize: true,
      labels: {
        boxWidth: 20,
        padding: 5,
      },
    },
  },
};

//------------------------------------
// BAR CHART JS
//------------------------------------
export const barchartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
  },
  scales: {
    x: {
      stacked: true, // Enable stacking for the x-axis
    },
    y: {
      stacked: true, // Enable stacking for the y-axis
    },
  },
};

export const barchartDataMock = {
  labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Sunday", "Saturday"],
  datasets: [
    {
      // label: "My First Dataset",
      data: [200, 450, 290, 367, 256, 543, 345],
      // borderWidth: 2,
      backgroundColor: "#9877f9",
      borderColor: "#9877f9",
      borderWidth: 2.0,
      pointBackgroundColor: "#ffffff",
      label: "Sales",
    },
  ],
};
